export const MAX_STONES = 10;
export const TOPICS = ['samples', 'consultation', 'quote'] as const;
export type Topic = (typeof TOPICS)[number];

export interface EnquiryPrefill {
  /** Product slugs to pre-select (`?product=a&product=b`), valid and unique, at most `MAX_STONES`. */
  products: string[];
  /** A variant of the first product (`?variant=<id>`). */
  variantId?: string;
  /** What the enquiry is about (`?topic=samples`) — fills a sensible opening message. */
  topic?: Topic;
}

const SLUG = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * What the contact page was opened with: `/contact-us?product=black-markino-granite-slab&variant=<id>&topic=samples#enquiry`.
 * The address is user input, so everything is validated and anything odd is simply ignored.
 */
export function parseEnquiryPrefill(params: URLSearchParams): EnquiryPrefill {
  const products: string[] = [];
  for (const value of params.getAll('product')) {
    const slug = value.trim().toLowerCase();
    if (slug.length <= 120 && SLUG.test(slug) && !products.includes(slug)) products.push(slug);
    if (products.length >= MAX_STONES) break;
  }
  const variant = params.get('variant');
  const topic = params.get('topic');
  return {
    products,
    ...(variant && UUID.test(variant) ? { variantId: variant } : {}),
    ...(topic && (TOPICS as readonly string[]).includes(topic) ? { topic: topic as Topic } : {}),
  };
}
